/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ summary: NonNullable<unknown> }} Iconik_Publish_Success_Text_With_ActionsInputs */

const en_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const fr_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const de_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const it_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const ru_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const es_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const zh_cn2_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const ja_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const hi_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

const pt_pt2_iconik_publish_success_text_with_actions = /** @type {(inputs: Iconik_Publish_Success_Text_With_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publishing was successful. ${i?.summary} Please verify the asset in Iconik before exiting.`)
};

/**
* | output |
* | --- |
* | "Publishing was successful. {summary} Please verify the asset in Iconik before exiting." |
*
* @param {Iconik_Publish_Success_Text_With_ActionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_text_with_actions = /** @type {((inputs: Iconik_Publish_Success_Text_With_ActionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_Text_With_ActionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_success_text_with_actions(inputs)
	if (locale === "de") return de_iconik_publish_success_text_with_actions(inputs)
	if (locale === "it") return it_iconik_publish_success_text_with_actions(inputs)
	if (locale === "ru") return ru_iconik_publish_success_text_with_actions(inputs)
	if (locale === "es") return es_iconik_publish_success_text_with_actions(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_success_text_with_actions(inputs)
	if (locale === "ja") return ja_iconik_publish_success_text_with_actions(inputs)
	if (locale === "hi") return hi_iconik_publish_success_text_with_actions(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_success_text_with_actions(inputs)
	return en_iconik_publish_success_text_with_actions(inputs)
});